<div>
  <div class="h3 red">{{ 'company_choose_existing_headline' | i18next }}</div>
    <div [innerHTML]="'company_choose_existing_text' | i18next"></div>
</div>


